import React, { ReactNode } from "react"
import { graphql } from "gatsby"
import { Image } from "components/image/Image"
import type { StrapiImageItem } from "_types/AssetsImage"
import "../../content-blocks/content-block.module.scss"
interface FaqProps {
  children: ReactNode
  image?: StrapiImageItem
}

export const FAQ = ({ children, image }: FaqProps) => {
  return (
    <div
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
      className="fr-faq-group-block__wrapper  u-clearfix text-wraps-image"
    >
            {image && (
        <Image
          alt={image.alternativeText ?? ""}
          className="fr-faq-group-block__image text-wraps-image__image"
          image={image}
        />
      )}
      <div className="text-wraps-image__content">
      {children}
      </div>

    </div>
  )
}

export const strapiQuery = graphql`
  fragment StrapiFaqFragment on STRAPI__COMPONENT_CONTENT_BLOCK_FAQ {
    answer {
      data {
        answer
      }
    }
    id
    question
    image {
      ...StrapiImageFragment
    }
  }
`
